class FieldsOfAction {
  constructor() {

    this.foaIcons = document.querySelectorAll('.ns-hf-icon');
    this.foaIconsArray = Array.prototype.slice.call(this.foaIcons);
    if(this.foaIconsArray.length > 0){
      this.addLinks();
    }
  }

  addLinks(){
    this.foaIconsArray.forEach(icon => {
      let link = icon.querySelector('.ns-hf-desc > a').getAttribute('href');
      icon.querySelector('.ns-hf-link').setAttribute('href', link);
    });
  }

}

export default FieldsOfAction;
